import { createRoot } from 'react-dom/client';
import { SignupApp } from './SignupApp';

createRoot(document.getElementById('signupApp')!).render(<SignupApp />);
